import React from 'react'

const Disclaimer = () => (
  <div id="content">
    This information does not replace or constitute legal advice. Users are
    responsible for ensuring compliance with the{' '}
    <i>Zero-Emission Vehicles Act</i> and <i>Regulations.</i>
  </div>
)

Disclaimer.defaultProps = {}

Disclaimer.propTypes = {}

export default Disclaimer
